import { Show, useForm } from "@refinedev/antd";
import { Button, Col, Form, Input, Row, Space } from "antd";
import { useMatch } from "react-router-dom";
import { v4 as randomId } from "uuid";

import { AppImageUploader, AppTitle, EFileTypes } from "../../../components";
import { errorNotification, successNotification } from "../../../helpers";
import { PlayerAwardType } from "../Lib";
import { AwardsDelete } from "../Awards-Delete/Awards-Delete";

export const AwardTypesShow = () => {
  const route = useMatch("/:parent/:id");
  const id = Number(route?.params.id);
  const { formProps, formLoading } = useForm<PlayerAwardType>({
    resource: "award-types",
    action: id ? "edit" : "create",
    id,
    dataProviderName: "awardTypesDataProvider",
    redirect: "list",
    ...successNotification({
      successData: {
        message: id ? "Тип награды изменен" : "Тип награды добавлен",
        type: "success",
      },
    }),
    ...errorNotification({}),
  });

  return (
    <Show
      isLoading={formLoading}
      title={
        <AppTitle isLoading={formLoading} canGoBack>
          {id
            ? formProps.initialValues?.displayName ||
              formProps.initialValues?.name ||
              "Редактировать тип награды"
            : "Добавить тип награды"}
        </AppTitle>
      }
      breadcrumb={false}
      headerButtons={
        <Space direction={"horizontal"}>
          {Boolean(id) && (
            <AwardsDelete
              name={
                formProps.initialValues?.displayName ||
                formProps.initialValues?.name ||
                "тип награды"
              }
              id={id}
              type={"page"}
              dataProviderName="awardTypesDataProvider"
              resource="award-types"
              redirectPath="/award-types"
              entityAccusative="тип награды"
            />
          )}
        </Space>
      }
      footerButtons={null}
      goBack={false}
    >
      <Form {...formProps} layout={"vertical"}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name={"name"}
              label={"Служебное название:"}
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать служебное название",
                },
                {
                  max: 80,
                  min: 3,
                  message: "Не более 80 символов и не менее 3 символов",
                },
              ]}
            >
              <Input placeholder={"Укажите служебное название"} />
            </Form.Item>
            <Form.Item
              name={"displayName"}
              label={"Название для вывода:"}
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать название для вывода",
                },
                {
                  max: 120,
                  min: 2,
                  message: "Не более 120 символов и не менее 2 символов",
                },
              ]}
            >
              <Input placeholder={"Укажите название для вывода"} />
            </Form.Item>
            <Form.Item
              name={"imageUrl"}
              label={"Изображение:"}
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Необходимо загрузить изображение",
                },
              ]}
            >
              <AppImageUploader
                type="NEWS"
                entityId={`${randomId()}`}
                serviceType={EFileTypes.NEWS}
                cropperProps={{
                  modalTitle: "Редактировать изображение",
                }}
                uploadProps={{
                  multiple: false,
                  children: "Изображение типа награды",
                  listType: "picture-card",
                }}
              />
            </Form.Item>

            <Space>
              <Button type={"primary"} htmlType={"submit"}>
                {id ? "Отредактировать" : "Добавить тип награды"}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Show>
  );
};
